<template>
  <template v-if="this.$route.name === 'Home'">
    <section class="container-xxl">
      <main-banner/>
    </section>
    <section class="container-xxl">
      <div class="sect-base">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-11">
            <h2 class="h2 ff-m fw-7 text-uppercase text-center mb-3 mb-md-4">О фонде</h2>
            <div class="fs-l fw-4 text-center pb-5">
              Фонд развития правовой культуры и правосознания – некоммерческая организация, реализующая
              проекты, направленные на развитие правовой культуры и правосознание граждан и
              предпринимателей.
            </div>
          </div>
        </div>
        <fund-banner/>
      </div>
    </section>
    <section class="container-xxl">
      <div class="sect-base">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-11">
            <h2 class="h2 ff-m fw-7 text-uppercase text-center mb-5 pb-2">Наши проекты</h2>
          </div>
        </div>
        <card-tabs :tabs="projects"/>
      </div>
    </section>
    <section class="container-xxl">
      <els-space-banner/>
    </section>
    <section class="container-xxl">
      <div class="sect-base">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-11">
            <h2 class="h2 ff-m fw-7 text-uppercase text-center mb-5 pb-2">Новости</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <swiper class="base-swiper"
                    :navigation="true"
                    :pagination="{ 'dynamicBullets': true }"
                    :breakpoints='{
                                "0": {
                                    "slidesPerView": 1,
                                    "slidesPerColumnFill": "row",
                                    "slidesPerColumn": 2,
                                    "navigation": false,
                                },
                                 "568": {
                                    "slidesPerView": 2,
                                    "spaceBetween": 30,
                                    "navigation": false,
                                },
                                "768": {
                                    "slidesPerView": 3,
                                    "spaceBetween": 30,
                                     "navigation": false,
                                },
                                 "1024": {
                                    "slidesPerView": 4,
                                    "spaceBetween": 30
                                },
                            }'>
              <swiper-slide v-for="(article, i) in articles" :key="`article-${i}`">
                <card-preview :post="article"/>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-dagray py-5">
      <div class="container-xxl">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-11">
            <h2 class="h2 ff-m fw-7 text-uppercase text-center text-white mb-5 pb-2">
              Наши партнеры
            </h2>
          </div>
        </div>
        <div class="row row-cols-1 row-cols-lg-3 justify-content-center">
          <div class="col col-split-third mb-lg-4" v-for="(post, i) in partners" :key="`partner-${i}`">
            <card-base :post="post" :tclass="['text-white']"/>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-6 col-lg-4 d-flex flex-column">
            <h6 class="h6 ff-m text-white text-center mt-5 pt-3 mb-4">
              Повысим уровень правовой культуры населения вместе
            </h6>
            <router-link to="/partnership" class="mx-auto">
              <base-button class="ff-m fw-6 text-center"
                           :color="['_back_light']"
                           :type="'button'">
                Стать партнером
              </base-button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="container-xxl" id="fund-contact">
      <div class="sect-base sect-base-top">
        <div class="row g-lg-5">
          <div class="col-12 col-md-6">
            <iframe class="contact-iframe"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2246.0809233051264!2d37.476685092378354!3d55.73972292359289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54952a693246b%3A0x384be2aee039ded9!2z0JzQuNC90YHQutCw0Y8g0YPQuy4sIDExLCDQnNC-0YHQutCy0LAsINCg0L7RgdGB0LjRjywgMTIxNDMz!5e0!3m2!1sru!2sge!4v1701763777487!5m2!1sru!2sge"
                style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div class="col-12 col-md-6">
            <h5 class="h5 ff-m fw-7 text-uppercase mb-4 mt-4 mt-md-0">Контакты</h5>
            <a href="mailto:info@legalculture.ru"
               class="d-flex flex-row align-items-center link-jump _blue mb-3">
              <svg class="icon me-2" viewBox="0 0 21 21">
                <use xlink:href='#icon-email' x="0" y="0"/>
              </svg>
              info@legalculture.ru
            </a>
            <a href="tel:+74957270900"
               class="d-flex flex-row align-items-center link-jump _blue mb-3">
              <svg class="icon me-2" viewBox="0 0 21 21">
                <use xlink:href='#icon-phone' x="0" y="0"/>
              </svg>
              +7 (495) 727-09-00
            </a>
            <a href="tel:+74957270900"
               class="d-flex flex-row align-items-center link-jump _blue mb-3">
              <svg class="icon me-2" viewBox="0 0 22 22">
                <use xlink:href='#icon-map' x="0" y="0"/>
              </svg>
              121108, г. Москва, ул. Минская, д. 11
            </a>
            <div>
              <strong>ИНН:</strong> 7730260692
            </div>
            <div>
              <strong>ОГРН:</strong> 1207700461760
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  <router-view v-else/>
</template>

<script>
import {mapState, mapActions} from 'vuex';

import CardBase from "../components/AllCards/CardBase";
import CardPreview from "../components/AllCards/CardPreview";
import CardTabs from "../components/AllCards/CardTabs";
import FundBanner from "../components/FundBanner";
import MainBanner from "../components/MainBanner";
import BaseButton from "../components/BaseButton";

import {Swiper, SwiperSlide} from 'swiper/vue';
import SwiperCore, {Pagination, Navigation} from 'swiper';

import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import ElsSpaceBanner from "../components/ElsSpaceBanner";

SwiperCore.use([Pagination, Navigation]);

export default {
  name: 'Home',
  components: {
    ElsSpaceBanner,
    Swiper,
    SwiperSlide,
    BaseButton,
    CardBase,
    CardPreview,
    CardTabs,
    FundBanner,
    MainBanner,
  },
  computed: {
    ...mapState({
      articles: state => state.articles.all,
      projects: state => state.projects.all,
      partners: state => state.partners.all
    })
  },
  methods: {
    ...mapActions({
      getArticles: 'articles/getArticles',
      getProjects: 'projects/getProjects',
      getPartners: 'partners/getPartners',
    }),
  },
  async mounted() {
    await this.getArticles();
    await this.getProjects();
    await this.getPartners();
  },
}
</script>

